import { Injectable } from '@angular/core';
import {ReplaySubject, Subject} from "rxjs";
import {ListResponse} from "../interface/response/list-response";
import {take} from "rxjs/operators";
import {HttpClient} from "@angular/common/http";
import {FilterService} from "./filter.service";

@Injectable({
  providedIn: 'root'
})
export class GlobalSearchService {
  private readonly partnerOfwcaCountedListSubject: ReplaySubject<ListResponse<any>> = new ReplaySubject<ListResponse<any>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
  ) { }

  public loadNotCountedList(page: number, pageSize: number, filters: object, observable?: Subject<ListResponse<any>>): void {
    this.httpClient
      .get(`/rest/crm/ofwcas-partners?disableCount=1&page=${page + 1}&pageSize=${pageSize}&` + this.filterService.parseFilters(filters))
      .pipe(take(1))
      .subscribe((result: ListResponse<any>) => {
        if (observable) {
          observable.next(result);
        } else {
          this.partnerOfwcaCountedListSubject.next(result);
        }
      });
  }
}
